// Kart Ekle / Kartı Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'cards.addCard';

export const addCardGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kart nasıl eklenir veya düzenlenir?'),
  intro: t(`${G}.intro`, 'Yeni bir fiziksel veya sanal kart tanımlar, kartı bir cariye ya da personele bağlarsınız. Sağdaki önizleme, girdiğiniz bilgilerle kartın nasıl görüneceğini gösterir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Kart bilgileri ve önizleme'),
    footer: t(`${G}.regions.footer`, 'Vazgeç / Kart Oluştur'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Fiziksel veya sanal kart seçin'),
      text: t(`${G}.s1.text`, '"Fiziksel Kart" elinizdeki bir kartı sisteme tanıtmak içindir: kartı okuyucuya okutun, "Kart UID" alanına okunan kod yazılır ve "Kart Numarası" aynı değerle otomatik dolar; isterseniz numarayı değiştirebilirsiniz. "Sanal Kart" seçilirse 16 haneli kart numarası otomatik üretilir; yanındaki yenile düğmesiyle yeni numara alabilirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Düzenlemede kart türü, Kart UID ve Kart Numarası değiştirilemez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Son kullanma ve CVV'),
      text: t(`${G}.s2.text`, '"Son Kullanma (MM/YY)" ve "CVV" isteğe bağlıdır. Girdiğiniz değerler sağdaki önizlemede görünür; kartın arka yüzünü görmek için önizlemedeki karta tıklayın.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Kart Tipi ve Cüzdanlar'),
      text: t(`${G}.s3.text`, '"Kart Tipi" ve en az bir "Cüzdan" seçmek zorunludur. Kart tipinin rengi önizlemeye yansır. Cüzdanlar listesinde birden fazla cüzdan işaretleyebilirsiniz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Kart Sahibi: Cari veya Personel'),
      text: t(`${G}.s4.text`, '"Cari" seçiliyse kartı bir cari hesaba bağlarsınız; yeni kartta "Genel Cari" hazır seçili gelir. "Personel" seçiliyse listeden bir personel seçmek zorunludur. Seçtiğiniz kişinin adı önizlemede kart sahibi olarak görünür. "Notlar" alanına isteğe bağlı açıklama yazabilirsiniz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. PDKS terminalleri (personel kartı)'),
      text: t(`${G}.s5.text`, 'Kart sahibi Personel ve kart Fiziksel ise "PDKS terminalleri" bölümü açılır. Kart devam kontrolünde (giriş-çıkış) kullanılacaksa kartın tanımlanacağı terminalleri işaretleyin; kart numarası terminale ayrıca yazılmaz. Baştaki sıfırlar yazılmasa da terminal 10 haneye tamamlar (16627763 → 0016627763).'),
      tips: [
        t(`${G}.s5.tip1`, 'Kaydettiğinizde personel yalnız işaretli terminallerde kalır; düzenlemede işareti kaldırdığınız terminallerden çıkarılır.'),
        t(`${G}.s5.tip2`, 'Kartın sahibini Personelden Cariye çevirirseniz, eski personel PDKS terminallerinden çıkarılır.'),
        t(`${G}.s5.tip3`, '"PDKS henüz bu şirkette açık değil veya cihaz yok." görürseniz önce Cihaz Yönetimi\'nden PDKS ekranı oluşturun.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kaydedin'),
      text: t(`${G}.s6.text`, '"Kart Oluştur" (düzenlemede "Güncelle") kartı kaydeder ve pencereyi kapatır. "Vazgeç" kaydetmeden kapatır.'),
      tips: [
        t(`${G}.s6.tip1`, 'Aynı kart numarası veya UID ile kayıtlı bir kart varsa "Bu kart zaten ekli." uyarısı çıkar; kart ikinci kez eklenemez.'),
        t(`${G}.s6.tip2`, 'Kart daha önce silinmişse uyarının yanında "Geri Yükle" düğmesi çıkar; yeni kart açmak yerine silinen kartı geri getirir.'),
      ],
    },
  ],
});
